
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import WithModel from '@/mixins/withModel';
import moment from 'moment';

@Options({})
export default class numberPlusMinus extends mixins(WithModel) {

    @Prop() max: number;

    declare localValue: number;

    created(){
        if(!this.localValue){
            this.localValue = 0;
            this.emitModel(this.localValue);
        }
    }

    prev(){
        if(this.localValue > 0){
            this.localValue--;
            this.emitModel(this.localValue);
        }
    }

    next(){
        if(this.localValue < this.max){
            this.localValue++;
            this.emitModel(this.localValue);
        }
    }

}
